import { Div, Button, Input, Span } from '@codesuma/baseline'
import { toFaDigits } from '../../helpers/digits'
import { Draft } from './draft'
import wizard from '../../components/wizard/index.module.css'
import style from './index.module.css'

const stepBody = (title: string) => {
    const base = Div()
    base.addClass(wizard.body)
    const heading = Div(title)
    heading.addClass(wizard.stepTitle)
    base.append(heading)
    return base
}

// When it runs: all day, or between two hours, and over how many days.
export const WhenSlide = (draft: Draft) => {
    const base = stepBody('کِی؟')
    const changed = () => base.emit('change')

    const allDayRow = Div()
    allDayRow.addClass(style.switchRow)
    const allDay = Input('', 'checkbox', { checked: draft.allDay })
    allDay.addClass(style.check)
    // The inline appearance baseline sets, out of the way, so the stylesheet
    // draws the box — the same removal the settings sheet's Choice makes.
    allDay.el.style.removeProperty('appearance')
    allDay.el.style.removeProperty('-webkit-appearance')
    allDayRow.append(allDay, Span('تمام‌روز'))
    base.append(allDayRow)

    const times = Div()
    times.addClass(style.times)
    const timeBox = (label: string, value: string, onPick: (v: string) => void) => {
        const box = Div()
        box.addClass(style.timeBox)
        const name = Div(label)
        name.addClass(style.label)
        const input = Input('', 'time', { value })
        input.addClass(style.time)
        input.on('input', ({ value: picked }: { value: string }) => {
            onPick(picked)
            changed()
        })
        box.append(name, input)
        return box
    }
    times.append(
        timeBox('از', draft.startTime, v => { draft.startTime = v }),
        timeBox('تا', draft.endTime, v => { draft.endTime = v }))
    base.append(times)

    // A stepper rather than a second date field: an event made from a day is
    // nearly always on that day, and the rare long one is a couple of taps.
    const spanRow = Div()
    spanRow.addClass(style.field)
    const spanLabel = Div('چند روز')
    spanLabel.addClass(style.label)
    const stepper = Div()
    stepper.addClass(style.stepper)
    const count = Div()
    count.addClass(style.count)
    const syncCount = () => count.text(toFaDigits(draft.days))
    const stepBtn = (label: string, by: number) => {
        const btn = Button(label)
        btn.addClass(style.step)
        btn.on('click', () => {
            const next = draft.days + by
            if (next < 1 || next > 365) return
            draft.days = next
            syncCount()
            changed()
        })
        return btn
    }
    // Minus first: the row reads right-to-left like the rest of the app.
    stepper.append(stepBtn('−', -1), count, stepBtn('+', 1))
    syncCount()
    spanRow.append(spanLabel, stepper)
    base.append(spanRow)

    // An all-day event has no hours to set; everything else does.
    const syncAllDay = () => times.style({ display: draft.allDay ? 'none' : '' })
    allDay.on('change', ({ value }: { value: boolean }) => {
        draft.allDay = value
        syncAllDay()
        changed()
    })
    syncAllDay()

    return base
}

